import {
  withTranslation,
} from 'react-i18next';

import RegattaEntryCrewmembersDialogView from './RegattaEntryCrewmembersDialogView';

const TranslatedComponent = withTranslation()(RegattaEntryCrewmembersDialogView);

const Component = TranslatedComponent;

export default Component;
